import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var ArrowLeftIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 16 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8.54.48a.75.75 0 0 1-.019 1.06L2.607 7.25H15.25a.75.75 0 0 1 0 1.5H2.607l5.914 5.71a.75.75 0 0 1-1.042 1.08L.232 8.542a.748.748 0 0 1 .001-1.085L7.48.46a.75.75 0 0 1 1.06.02Z"
        })
    }));
};
